<template>
    <div>
        <div class="mt-2">
            <v-file-input :fileId="fields.fileId" @change="fileWasUpdated" type="pdf"></v-file-input>
            <span class="text-red-500 text-xs" v-if="getError('fileId')">{{ getError('fileId') }}</span>
        </div>
    </div>
</template>

<script>
import {mapActions, mapState} from "pinia";
import {qrCodeFormStore} from "@/scripts/store/qr_code_form.store";
import VButton from "@/scripts/components/app/common/VButton.vue";
import VFileInput from "@/scripts/components/app/common/VFileInput.vue";
import {FileType} from "@/scripts/api/storage";

export default {
    components: {VFileInput, VButton},
    props: {
        destinationId: {
            required: true
        },
        errors: {
            default: []
        }
    },

    computed: {
        ...mapState(qrCodeFormStore, ['code']),
        fields: {
            get() {
                return this.code.destinations[this.destinationId].data
            },
            set(val) {
                this.updateDestinationData(this.destinationId, val)
            }
        }
    },

    methods: {
        FileType() {
            return FileType
        },
        ...mapActions(qrCodeFormStore, ['updateDestinationData']),
        fileWasUpdated(file) {
            if (file) {
                this.fields.fileId = file.id
            } else {
                this.fields.fileId = ''
            }
        },
        getError(field) {
            return this.errors[field]
        }
    }
}
</script>